import { getVariation } from 'public/designs/index';
class AnimatedDividers extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        if (this.attributes.cesettings && !this.initialized) this.initAnimatedDividers();
        this.initialized = true;
    }
    disconnectedCallback() {
        while (this.attributes.length > 0) {
            this.removeAttribute(this.attributes[0].name);
        }
    }
    static get observedAttributes() {
        return ["cesettings"]
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if (this.attributes.cesettings && !this.initialized) this.initAnimatedDividers();
        this.initialized = true;
    }
    renderAnimatedDividers() {
        this.style.display = "block";
        // this.style.width = "100%";
        // this.style.height = "100%";

        let initStyleBlock = `
<style>
  animated-dividers {
    width: 100%;
    height: 100%;
  }
  #wix-internal-id {
    position: relative;
    display: block !important;
    height: 100% !important;
    min-height: 0px !important;
  }
</style>`;
        this.innerHTML = initStyleBlock;

        this.widgetHeight = this.offsetHeight;
        // if(!this.widgetHeight || this.widgetHeight == 0) return;
        const defaultTo = (a, b) => a ?? b;
        if (this.attributes && !this.attributes.cesettings) return;
        const wixsettings = JSON.parse(this?.attributes?.cesettings?.value ?? '{}');
        const compId = wixsettings.widgetId;

        let shapeVariation = defaultTo(wixsettings.shapeVariation, 'wave_big');
        let animationLocation = defaultTo(wixsettings.animationLocation, '_wrapped');
        let supportsBottom = defaultTo(wixsettings.supportsBottom, true);

        if (supportsBottom && animationLocation != '_top') shapeVariation += animationLocation;
        const flipAnimation = defaultTo(wixsettings.flipAnimation, false);
        const shapeColor = defaultTo(wixsettings.backgroundColor, "#0057E1");
        const internal = defaultTo(wixsettings.internal, "true");

        let showMessage = defaultTo(wixsettings.showMessage, false),
            upgradeMessage = "";
        if (showMessage) upgradeMessage = `<div class="upgrade-message">This animation option will only publish after you upgrade.</div>`;

        // Muatable variables
        let shapeHeight = defaultTo(wixsettings.shapeHeight, 120);
        let minHeight = `${shapeHeight}px`;
        if (shapeHeight % 2 != 0) shapeHeight++;
        let bgOpacity = defaultTo(wixsettings.backgroundOpacity, 100);
        bgOpacity = bgOpacity / 100;
        let gradientColor = defaultTo(wixsettings.gradientColor, "#A900E1");
        let gradientOpacity = defaultTo(wixsettings.gradientOpacity, 0);
        gradientOpacity = gradientOpacity / 100;
        if (gradientOpacity == 0) gradientColor = shapeColor;
        let gradientOrientation = defaultTo(wixsettings.gradientOrientation, 'Diagonal left');
        switch (gradientOrientation) {
        case "Diagonal right":
            gradientOrientation = 'gradientTransform="rotate(135 0.5 0.5)"';
            break;
        case "Vertical":
            gradientOrientation = 'x1="0" x2="0" y1="0" y2="100%"';
            break;
        case "Horizontal":
            gradientOrientation = '';
            break;
        default:
            gradientOrientation = 'gradientTransform="rotate(45 0.5 0.5)"';
        }
        let animationSpeed = defaultTo(wixsettings.animationSpeed, 'Normal');
        switch (animationSpeed) {
        case "Very slow":
            animationSpeed = 10;
            break;
        case "Slow":
            animationSpeed = 25;
            break;
        case "Moderately slow":
            animationSpeed = 50;
            break;
        case "Moderately fast":
            animationSpeed = 150;
            break;
        case "Fast":
            animationSpeed = 200;
            break;
        case "Very fast":
            animationSpeed = 300;
            break;
        default:
            animationSpeed = 100;
        }
        animationSpeed = 100 / animationSpeed;

        let topSvg = `<div class="svgm-wrap svgm-wrap-top">
      <svg class="pattern-svg" version="1.1" height="${shapeHeight}" width="100%">
        <rect class="animdiv-top" fill="url(#grad_${compId})" mask="url(#mask_${compId})" width="100%" height="100%"/>
        <rect class="animdiv-top single-svg" fill="url(#grad_${compId})" mask="url(#mask_single_${compId})" width="100%" height="100%"/>
      </svg>
    </div>`,
            bottomSvg = "",
            cssMod = `.svgm_${compId} > .svgm-wrap-outer > .svgm-wrap.svgm-wrap-center {
      z-index: 2;
      height: 100%;
      clip-path: inset(${shapeHeight-1}px 0 0 0);
    }`;
        if (shapeVariation.includes("_bottom")) {
            minHeight = "100%";
            shapeVariation = shapeVariation.replace("_bottom", "");
            topSvg = "";
            bottomSvg = `<div class="svgm-wrap svgm-wrap-bottom">
  <svg class="pattern-svg" version="1.1" height="${shapeHeight}" width="100%">
    <rect class="animdiv-bot" fill="url(#grad_2_${compId})" mask="url(#mask_${compId})" width="100%" height="100%"/>
    <rect class="animdiv-bot single-svg" fill="url(#grad_2_${compId})" mask="url(#mask_single_${compId})" width="100%" height="100%"/>
  </svg>
  </div>`;
            cssMod = `
  .svgm_${compId} > .svgm-wrap-outer > .svgm-wrap.svgm-wrap-center {
    z-index: 2;
    height: 100%;
    clip-path: inset(0 0 ${shapeHeight-1}px 0);
  }
  .svgm_${compId} > .svgm-wrap-outer > .svgm-wrap.svgm-wrap-bottom {
    bottom: 0;
    z-index: 0;
    transform: translateY(0) rotateZ(180deg);
  }`;
            if (shapeVariation == "Wave: Steps") {
                bottomSvg = `<div class="svgm-wrap svgm-wrap-bottom">
    <svg class="pattern-svg" version="1.1" height="${shapeHeight}" width="100%">
      <rect class="animdiv-bot" fill="url(#grad_2_${compId})" mask="url(#mask_2_${compId})" width="100%" height="100%"/>
    </svg>
    </div>`;
            }
        }
        if (shapeVariation.includes("_wrapped")) {
            minHeight = `${shapeHeight*2}px`;
            shapeVariation = shapeVariation.replace("_wrapped", "");
            bottomSvg = `<div class="svgm-wrap svgm-wrap-bottom">
  <svg class="pattern-svg" version="1.1" height="${shapeHeight}" width="100%">
    <rect class="animdiv-bot" fill="url(#grad_2_${compId})" mask="url(#mask_${compId})" width="100%" height="100%"/>
    <rect class="animdiv-bot single-svg" fill="url(#grad_2_${compId})" mask="url(#mask_single_${compId})" width="100%" height="100%"/>
  </svg>
  </div>`;
            cssMod = `
  .svgm_${compId} > .svgm-wrap-outer > .svgm-wrap.svgm-wrap-center {
    z-index: 2;
    height: 100%;
    clip-path: inset(${shapeHeight-1}px -1px ${shapeHeight-1}px -1px);
  }
  .svgm_${compId} > .svgm-wrap-outer > .svgm-wrap.svgm-wrap-bottom {
    bottom: 0;
    z-index: 0;
    transform: translateY(0) rotateZ(180deg);
  }`;
            if (shapeVariation == "wave_steps") {
                bottomSvg = `<div class="svgm-wrap svgm-wrap-bottom">
    <svg class="pattern-svg" version="1.1" height="${shapeHeight}" width="100%">
      <rect class="animdiv-bot" fill="url(#grad_2_${compId})" mask="url(#mask_2_${compId})" width="100%" height="100%"/>
    </svg>
    </div>`;
            }
        }

        let blendColors = function (colorA, colorB, amount) {
            const [rA, gA, bA] = colorA.match(/\w\w/g).map((c) => parseInt(c, 16));
            const [rB, gB, bB] = colorB.match(/\w\w/g).map((c) => parseInt(c, 16));
            const r = Math.round(rA + (rB - rA) * amount).toString(16).padStart(2, '0');
            const g = Math.round(gA + (gB - gA) * amount).toString(16).padStart(2, '0');
            const b = Math.round(bA + (bB - bA) * amount).toString(16).padStart(2, '0');
            return '#' + r + g + b;
        }
        gradientColor = blendColors(shapeColor, gradientColor, gradientOpacity);
        let splashAdj = shapeHeight / 2 + 1;
        if (shapeHeight == 120 || shapeHeight == 140 || shapeHeight == 160) splashAdj = shapeHeight / 2;
        this.innerHTML += `
  <style>
    .svgm_${compId} mask {
      fill: black;
    }
    #wix-internal-id {
      height: 100%;
    }
    #${compId},
    [data-mesh-id=${compId}inlineContent],
    ${this.tagName} {
      width: 100%;
      overflow: hidden;
    }

    #${compId} {
      left: auto !important;
      margin: 0 !important;
    }
    ${this.tagName} {
      position: relative;
      height: 100%;
    }
    .svgm_${compId} {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 0;
      min-height: ${minHeight};
    }
    .svgm_${compId} > .svgm-wrap-outer {
      position: absolute;
      width: 100%;
                height: 100%;
      left: 0;
      top: 0;
      opacity: ${bgOpacity}
    }
    .svgm_${compId} > .svgm-wrap-outer > .svgm-wrap {
      position: absolute;
      height: 120px;
      height: ${shapeHeight}px;
      width: 100%;
      overflow: hidden;
    }
    .svgm_${compId} > .svgm-wrap-outer > .svgm-wrap.svgm-wrap-def {
      overflow: visible;
    }
    .svgm_${compId} > .svgm-wrap-outer > .svgm-wrap svg {
      width: 100%;
      height: 100vh;
      stroke: none;
      fill: white;
    }
    .svgm_${compId}[data-view-mode="Site"] > .svgm-wrap-outer > .svgm-wrap svg {
      height: ${this.widgetHeight}px;
    }
    .svgm_${compId} > .svgm-wrap-outer > .svgm-wrap svg path.svgm-opacity {
    stroke: none;
    stroke-width: 0;
    }
    .svgm_${compId} > .svgm-wrap-outer > .svgm-wrap.svgm-wrap-top {
    top: 0;
    z-index: 1;
    }
    ${cssMod}
    .svgm_${compId} > .svgm-wrap-outer > .svgm-wrap > svg {
    width: 100%;
    overflow: visible;
    display: block;
    }
    .svgm_${compId} > .svgm-wrap-outer > .svgm-wrap:after {
    background: #FFFFFF;
    }
    .svgm_${compId} .svgm-content {
    position: relative;
    z-index: 3;
    min-height: 120px;
    min-height: ${shapeHeight}px;
    display: grid;
    align-items: center;
    padding: 0 24px;
    grid-template-columns: minmax(100%,1140px);
    justify-items: center;
    }
    .svgm_${compId} .svgm-content > div {
    width: 100%;
    max-width: 1140px;
    padding: 32px 0px;
    }
    .svgm_${compId} .svgm-mask {
    transform-origin: center;
    }
    .svgm_${compId} image:not(.svgm-pattern):not(.svgm-off) {
    transform-origin: center;
    }
    .svgm_${compId} image.svgm-off {
    transform-origin: center;
    }
    .svgm_${compId} .svgm-pattern {
    width: 100px;
    height: 100px;
    }
    .svgm_${compId} .svgm-mask-top {
    transform: translate(0,0px) scaleX(1);
    }
    .svgm_${compId} .svgm-mask-bottom {
    transform: translate(0,0px) scaleX(1);
    }
    .svgm_${compId} .svgm-gap-seal {
          transform: translate(0,-2px);
    }
    .svgm_${compId} .observer {
      position: absolute;
      pointer-events: none;
      top: 0;
      bottom: 0;
      left: calc(50% - 1px);
      width: 2px;
    }
    #mask_single_${compId} rect {
        transform: translate(-960px,0);
    }
    .svgm_${compId}.invertedtrue #mask_2_${compId} rect,
    .svgm_${compId}.invertedtrue #mask_${compId} rect {
      transform: scale(-1,1);
      transform-origin: center;
    }
    .svgm_${compId}.invertedtrue #mask_single_${compId} rect {
      transform: scale(-1,1) translate(-960px,0);;
      transform-origin: center;
    }
    .svgm_${compId}.invertedfalse g.truck-reverse {
      display: none;
    }
    .svgm_${compId}.invertedtrue g.truck-forwards {
      display: none;
    }
    @media only screen and (-moz-min-device-pixel-ratio: 2),
           only screen and (-o-min-device-pixel-ratio: 2/1),
           only screen and (-webkit-min-device-pixel-ratio: 2),
           only screen and (min-device-pixel-ratio: 2) {
     .svgm_${compId} {
       clip-path: inset(0.5px 0 0.5px 0);
     }
    }
    .upgrade-message {
      background-color: #eedbf4;
      box-sizing: border-box;
      color: #2b5672;
      font-family: HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,Helvetica,Arial,メイリオ,meiryo,ヒラギノ角ゴ pro w3,hiragino kaku gothic pro,sans-serif;
      font-size: 12px;
      line-height: 18px;
      max-height: 100%;
      overflow: hidden;
      padding: 6px;
      position: absolute;
      text-align: center;
      bottom: 0;
      width: 100%;
      z-index: 10;
    }
    [data-variation="special_splash"] rect {
      shape-rendering: optimizeSpeed;
    }
    [data-variation="special_splash"] #mask_single_${compId} rect {
      transform: scale(2) translate(-960px,0);
      transform-origin: center ${splashAdj}px;
    }
  </style>
  ${upgradeMessage}
  <div class="svg-metamorph is_${compId} svgm_${compId} inverted${flipAnimation}" data-variation="${shapeVariation}" data-view-mode="${wixsettings.viewMode}">
    <div class="svgm-wrap-outer">
      <div class="svgm-wrap svgm-wrap-def">
        <svg>
          <defs>
            <linearGradient id="grad_${compId}" ${gradientOrientation}>
              <stop offset="0%" stop-color="${shapeColor}"></stop>
              <stop offset="100%" stop-color="${gradientColor}"></stop>
            </linearGradient>
            <linearGradient id="grad_2_${compId}" ${gradientOrientation}>
              <stop offset="0%" stop-color="${gradientColor}"></stop>
              <stop offset="100%" stop-color="${shapeColor}"></stop>
            </linearGradient>
            <linearGradient id="paper_fade_${compId}" gradientUnits="userSpaceOnUse" x1="960" y1="240" x2="960" y2="-9.094947e-13">
              <stop  offset="0" style="stop-color:#FFFFFF"/>
              <stop  offset="1" style="stop-color:#CCCCCC"/>
            </linearGradient>
            <linearGradient id="fade_${compId}" y2="1" x2="0">
              <stop offset="0" stop-color="white" stop-opacity="0"></stop>
              <stop offset="0.018" stop-color="white" stop-opacity="0.002"></stop>
              <stop offset="0.048" stop-color="white" stop-opacity="0.008"></stop>
              <stop offset="0.09" stop-color="white" stop-opacity="0.021"></stop>
              <stop offset="0.139" stop-color="white" stop-opacity="0.042"></stop>
              <stop offset="0.198" stop-color="white" stop-opacity="0.075"></stop>
              <stop offset="0.27" stop-color="white" stop-opacity="0.126"></stop>
              <stop offset="0.35" stop-color="white" stop-opacity="0.194"></stop>
              <stop offset="0.435" stop-color="white" stop-opacity="0.278"></stop>
              <stop offset="0.53" stop-color="white" stop-opacity="0.382"></stop>
              <stop offset="0.66" stop-color="white" stop-opacity="0.541"></stop>
              <stop offset="0.79" stop-color="white" stop-opacity="0.738"></stop>
              <stop offset="1" stop-color="white" stop-opacity="1"></stop>
            </linearGradient>
            ${getVariation(shapeVariation)({compId,shapeHeight,animationSpeed,flipAnimation})}
          </defs>
        </svg>
      </div>
      ${topSvg}
      <div class="svgm-wrap svgm-wrap-center">
        <svg version="1.1" height="${shapeHeight}" width="100%">
            <rect fill="url(#grad_${compId})" width="100%" height="100%"/>
        </svg>
      </div>
      ${bottomSvg}
    </div>
    <div class="observer"></div>
  </div>
`;
    }
    initAnimatedDividers() {
        const wixsettings = JSON.parse(this?.attributes?.cesettings?.value ?? '{}');
        const viewMode = wixsettings.viewMode;
        const compId = wixsettings.widgetId;

        let this_ = this,
            rerender = 10000,
            resizeTimeout;
        this.renderAnimatedDividers();

        if (viewMode == "Editor") {
            let resizeWidth = window.innerWidth,
                resizeHeight = window.innerHeight;
            window.addEventListener("resize", function () {
                if (window.innerWidth !== resizeWidth || window.innerHeight !== resizeHeight) {
                    clearTimeout(resizeTimeout);
                    if (this_.querySelector(".observer")) {
                        this_.innerHTML = "";
                    }
                    resizeTimeout = setTimeout(function () {
                        this_.renderAnimatedDividers();
                    }, 500);
                    resizeWidth = window.innerWidth;
                    resizeHeight = window.innerHeight;
                }
            });

        } else {
            if (this.querySelector("pattern")) this.querySelector("pattern").insertAdjacentHTML('beforeend', '<path opacity="0" d=""><animate attributeType="xml" attributeName="d" values="M 0 0 L 1920 0 L 1920 1920 L 0 1920 Z;M 0 0 L 1920 0 L 1920 1920 L 0 1920 Z;M 0 0 L 1920 0 L 1920 1920 L 0 1920 Z" keyTimes="0;0.5;1" keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline" begin="-4.95s" dur="5s" repeatCount="indefinite"></animate></path>');
            window.addEventListener("resize", function () {
                rerender++;
                let maskRects = document.querySelectorAll(`.svgm_${compId} .svgm-wrap-def mask rect`);
                for (let i = 0; i < maskRects.length; i++) {
                    maskRects[i].style.maxWidth = rerender;
                }
            });
        }

    }
}
customElements.define("animated-dividers", AnimatedDividers);